export default {
  coffeeData: {
    windBreaker: "Árvore quebra-vento",
    horticultureInfo: "Árvore de horticultura",
    shadeTree: "Árvore de sombra",
    coffeeVariety: "Variedade de café",
    coffeeSpecies: "Espécies de café",
    coffeeCherryQuality: "Qualidade da Cereja de Café",
    processingBatchQuality: "Qualidade do Lote de Processamento",
    greenCoffeeQuality: "Qualidade de Café Verde",
    processType: "Tipo de Processo",
    updateWindBreaker: "Atualizar tipo de árvore quebra-vento",
    addWindBreaker: "Adicionar novo tipo de árvore quebra vento",
    updateHorticultureInfo:
      "Atualizar informações de tipo de árvore na horticultura",
    addHorticultureInfo:
      "Adicionar novas informações de tipo de árvore na horticultura",
    updateShadeTree: "Atualizar tipo de árvore de sombra",
    addShadeTree: "Adicionar novo tipo de árvore para sombra",
    updateCoffeeVariety: "Atualizar tipo de árvore coffeeVariety",
    addCoffeeVariety: "Adicione o novo tipo de árvore à variedade de café",
    deleteVarietyTitle: "Excluir variedade",
    deleteVarietyMessage: "Tem certeza de que deseja excluir a variedade?",
    updateCoffeeSpecie: "Atualizar espécie de café",
    deleteSpecieTitle: "Excluir espécie",
    deleteSpecieMessage: "Tem certeza de que deseja excluir Espécie?",
    addCoffeeSpecie: "Adicionar nova espécie de café",
    variety: "Variedade",
    selectVariety: "Selecionar variedade",
    deleteCoffeeRecord: "Tem certeza de que deseja excluir o registro?",
    deleteCoffeeData: "Excluir dados de café",
    topicRequired: "O nome do tópico é obrigatório",
    coffeeAddSuccess: "Espécie de café adicionada com sucesso.",
    treeTypeSuccess: "Tipo de árvore adicionado com sucesso..",
    treeTypeUpdateSuccess: "Tipo de árvore atualizado com sucesso.",
    coffeeVarietySuccess: "Variedade de café adicionada com sucesso.",
    coffeeSpecieSuccess: "Espécie de café atualizada com sucesso.",
    nameRequired: "O nome é obrigatório",
    notFound: "Nenhum dado do Admin encontrado.",
  },
  cacaoData: {
    cacao: "Cacau",
    cacaoOverview: "Visão Geral do Cacau",
    cacaoVariety: "Variedade de Cacau",
    cacaoSpecies: "Espécie de Cacau",
    deleteCacaoData: "Excluir Dados de Cacau",
    cacaoWeight: "Peso do Cacau",
    cacaoType: "Tipo de Cacau",
    productWeight: "Peso do Produto",
    productType: "Tipo de Produto",
    productPricePerKg: "Preço por KG",
    registerFermentation: "Registrar Fermentação",
    batchVisualIdentification: "Identificação Visual do Lote",
    initialWeight: "Peso Inicial",
    finalWeight: "Peso Final",
    performance: "Desempenho",
    fermentationPercentage: "Porcentagem de Fermentação",
    fermetationMethod: "Método de Fermentação",
    boxes: "Caixas",
    piles: "Pilhas",
    bags: "Sacos",
    selectZone: "Selecionar Zona",
    selectPlantation: "Selecionar Plantação",
    deliveryMethod: "Método de Entrega",
    totalPrice: "Preço Total",
  },
  memberDataSection: {
    import: "Importar",
    buyingStation: "Estação de Compra",
    factory: "Fábrica",
    factories: "Fábricas",
    factoriesName: "Nome da Fábrica",
    factoriesProdChart: "Gráfico de Produção de Fábricas",
    factoryInfo: "Informações da Fábrica",
    continue: "Continuar",
    farmerId: "ID do Agricultor",
    farmerName: "Nome do Agricultor",
    farmerAddress: "Endereço do Agricultor",
    quality: "Qualidade",
    quantity: "Quantidade",
    importAll: "Importar Tudo",
    importSelected: "Importar Selecionado",
    fileLoaded: "Arquivo carregado com sucesso",
    incorrectHeaders: "Cabeçalhos incorretos",
    processingBatch: "Processando Lote",
    purchaseOrder: "Ordem de Compra",
    startDate: "Data de Início",
    endDate: "Data de Término",
    selectCrop: "Selecionar Cultura",
    purchasingOrder: "Ordem de Compra",
    totalCoffeeCherry: "Total de Café Cereja",
    airHumidity: "Umidade do Ar",
    density: "Densidade",
    temperature: "Temperatura",
    beanMoistureContent: "Conteúdo de Umidade do Feijão",
    processType: "Tipo de Processo",
    batchRating: "Selecione a Classificação do Lote",
    purchaseDate: "Data de Compra",
    selectFarmer: "Selecionar Agricultor",
    selectFarm: "Selecionar Fazenda",
    selectPlantation: "Selecionar Plantação",
    coffeeVariety: "Variedade de Café",
    coffeeSpecies: "Espécie de Café",
    coffeeCherryQuantity: "Quantidade de Café Cereja",
    coffeeCherryQuality: "Qualidade do Café Cereja",
    coffeeType: "Tipo de Café",
    pricePerKg: "Preço Por Kg",
    processingDone: "Processamento Concluído",
    processedCoffeeOut: "Café Processado",
    farmer: "Agricultor",
    farm: "Fazenda",
    plantation: "Plantação",

    // Recently added
    farmers: "Agricultores",
    farmLimitUsed: "Limite de Fazenda Usado",
    phoneNumber: "Número de Telefone",
    farmSize: "Tamanho da Fazenda",
    farmLocation: "Fazenda/Localização",
    date: "Data",
    status: "Status",
    noFarmers: "Nenhum Agricultor Encontrado",
    approveReject: "Aprovar/Rejeitar",
    farms: "Fazendas",
    crops: "Culturas",
    equipment: "Equipamento",
    noFarms: "Nenhuma Fazenda Encontrada",
    views: "Visualizar",
    selectStatus: "Selecionar Status",
    approved: "Aprovado",
    rejected: "Rejeitado",
    reject: "Rejeitar",
    approve: "Aprovar",
    cancel: "Cancelar",
    add: "Adicionar",
    describeYourReason: "Descreva sua razão aqui",
    userInformation: "Informações do Usuário",
    userFarmRequest: "Solicitação de Fazenda do Usuário",
    userFarmInformation: "Informações da(s) Fazenda(s) do Usuário",
    activity: "Atividade",
    activityType: "Tipo de Atividade",
    farmZone: "Zona da Fazenda",
    farmerView: "Visualização do Agricultor",
    cropType: "Tipo de Cultura",
    cropVarity: "Variedade da Cultura",
    area: "Área",
    cost: "Custo",
    geofence: "Geofence",
    map_views: "Visualização no Mapa",
    viewAllFarms: "Visualizar Todas as Fazendas",
    farmersDetails: "Detalhes do Agricultor",
    download: "Baixar",
    pOrder: {
      addNew: "Adicionar Novo",
      viewAll: "Visualizar Todos",
      selectDate: "Selecionar data",
      makeSelection: "Fazer uma seleção",
      coffeeType: "Tipo de café quantidade",
      enterPrice: "Digite o Preço",
      reqPurchaseDate: "A data de compra é obrigatória",
      reqFarmer: "O agricultor é obrigatório",
      reqCoffeeQnty: "Quantidade de Café Cereja é obrigatória",
      reqPrice: "O Preço Por Kg é obrigatório",
      grandTotal: "TOTAL GERAL",
      selectDateRange: "Selecionar Intervalo de Datas",
      import: "Importar",
      purchaseId: "ID de Compra",
      purchaseDate: "Data de Compra",
      farmerName: "Nome do Agricultor",
      quality: "Qualidade",
      quantity: "Quantidade",
      pricePerKg: "Preço Por Kg",
      selectBuyingStation: "Selecionar estação de compra",
      searchUser: "Pesquisar Usuários",
    },
    farmActivity: "Atividade da Fazenda",
    showOnMap: "Mostrar no Mapa",
    farmInformation: "Informações da Fazenda",
    dateOfEntry: "Data de Entrada",
    farmID: "ID da Fazenda",
    ownershipType: "Tipo de Propriedade",
    locationAddress: "Endereço da Localização",
    goalType: "Tipo de Meta",
    totalSize: "Tamanho Total",
    zones: "Zonas",
    farmActivities: "Atividades da Fazenda",
    farmDetails: "Detalhes da Fazenda",
    totalFarmsRegistered: "Total de Fazendas Registradas",
    totalFarmArea: "Área Total da Fazenda",
    totalZone: "Total de Zonas",
    zone: "Zona",

    totalCost: "Custo Total",
    selectFarmZone: "Selecionar Zona/Fazenda",
    productionType: "Tipo de Produção",
    certifications: "Certificações",
    geofences: "Geofences",
    farmsChart: "Gráfico de Fazendas",
    
    
    // Buying Station specific translations
    buyingStations: "Estações de Compra",
    registerBuyingStation: "Registrar Estação de Compra",
    registerFactory: "Registrar Fábrica",
    loadingFactory: "Carregando Fábrica...",
    loadingBuyingStation: "Carregando Estação de Compra...",
    searchBuyingStation: "Pesquisar Estação de Compra",
    searchFactory: "Pesquisar Fábrica",
    nameAndId: "Nome / ID",
    email: "E-mail",
    mobileNumber: "Número de Celular",
    role: "Função",
    actions: "Ações",
    view: "Visualizar",
    edit: "Editar",
    activate: "Ativar",
    deactivate: "Desativar",
    operator: "Operador",
    supplier: "Fornecedor",
    active: "Ativo",
    deactivated: "Desativado",
    activatedSuccessfully: "Estação de compra ativada com sucesso",
    deactivatedSuccessfully: "Estação de compra desativada com sucesso",
  
    factoryActivatedSuccessfully: "Fábrica ativada com sucesso",
    factoryDeactivatedSuccessfully: "Fábrica desativada com sucesso",
    factoryRegisteredSuccessfully: "Fábrica registrada com sucesso",
    
    // Buying Station Details specific translations
    userDetails: "Detalhes do Usuário",
    name: "Nome",
    provinceState: "Província/Estado",
    villageCityTown: "Vila/Cidade/Município",
    country: "País",
    associatedFarms: "Fazendas Associadas",
    back: "Voltar",
    addPurchaseOrder: "Adicionar Ordem de Compra",
    search: "Pesquisar",
    orderId: "ID do Pedido",
    farmFarmer: "Fazenda / Agricultor",
    coffeeSpeciesVariety: "Espécie / Variedade de Café",
    quantityPrice: "Quantidade / Preço",
    delete: "Excluir",
    
    // Processing Batch specific translations
    addProcessingBatch: "Adicionar Lote de Processamento",
    batchId: "ID do Lote",
    lots: "Lotes",
    greenCoffeeOut: "Café Verde Saída",
    startEndDate: "Data de Início/Data de Término",
    
    // Associated Farms specific translations
    addFarm: "Adicionar Fazenda",
    farmNameAndId: "Nome e ID da Fazenda",
    addressOfProduction: "Endereço de Produção",
    areaHa: "Área (ha)",
    type: "Tipo",
    eudrDeforestationStatus: "Status de Desmatamento EUDR",
    eudrDeforestationStatusTT: "Status de Avaliação de Risco de Desmatamento EUDR",
    zeroNegligibleProbability: "Probabilidade Zero/Desprezível",
    assessments: "Avaliações",
    riskAssessment: "Avaliação de Risco",
    compliant: "Conforme",
    nonCompliant: "Não Conforme",
    pending: "Pendente",
    dateOfSubmission: "Data de Submissão",
    dateOfExpiry: "Data de Validade",
    
    confirmDialog: {
      delete: {
        title: "Excluir Estação de Compra",
        message: "Tem certeza de que deseja excluir esta estação de compra?",
        confirmBtn: "Excluir",
      },
      activate: {
        title: "Ativar",
        message: "Tem certeza de que deseja ativar este {entity}?",
        confirmBtn: "Ativar",
      },
      deactivate: {
        title: "Desativar",
        message: "Tem certeza de que deseja desativar este {entity}?",
        confirmBtn: "Desativar",
      },
    },
    
    registerNewFactory: "Registrar Nova Fábrica",
    selectHowYouWantToProceed: "Selecione como deseja prosseguir",
    single: "Único",
    multiple: "Múltiplo",
    user: "Usuário",
    createNewFactory: "Criar uma Nova Fábrica",
    factoryName: "Nome da Fábrica",
    factoryNumber: "Número da Fábrica",
    firstName: "Primeiro Nome",
    lastName: "Sobrenome",
    primaryEmailAddress: "Endereço de E-mail Principal",
    submit: "Enviar",
    downloadTemplate: "Baixar Modelo",
    templateInfo: "Baixe o modelo de arquivo para ver o formato necessário para o registro em massa.",
    templateFormat: "Forneça o arquivo no formato CSV.",
    selectFileToUpload: "Selecione o arquivo para fazer o upload dos dados",
    uploadFileOrDragAndDrop: "ou arraste e solte aqui",
  },
}